import styled from 'styled-components';

export const Container = styled.div`
  .company {
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #000000;
  }

  .cnpj {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #666666;
  }
`;
